import React from 'react';
import ButtonBase from './ButtonBase';
import { TButtonsDefault } from './types/TButtons';

const Primary = ({ as = 'button', ...rest }: TButtonsDefault) => <ButtonBase {...rest} as={as} kind="primary" />;

export default Primary;
